function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M25.06 21.75c-1.75-2.64-3-6.57-3.76-11.65-.09-.55-.15-1.07-.21-1.58h1a.9.9 0 00.9-.9V5.69a.9.9 0 00-.9-.91h-1.34c-.1-1.63-.12-2.85-.12-3.38a.9.9 0 00-.91-.9h-2.31a.9.9 0 00-.9.9v.09a25.63 25.63 0 01.06 3.29h-1.19a.9.9 0 00-.91.91v1.93a.9.9 0 00.91.9h.9c-.17 1.37-.42 2.88-.78 4.56-.9 4.22-10 4.74-10.14 4.77h-.48L4.31 29.5h20.24l.72-7a1.16 1.16 0 00-.21-.75zM17.58 1.53h2c0 .63 0 1.76.12 3.23h-2.06a32.06 32.06 0 00-.06-3.23zm-2.06 4.3H22v1.66h-6.48zm8.07 22.62H5.4l.49-9.6c2-.16 9.68-1.11 10.62-5.54.38-1.76.63-3.36.8-4.77H20c.52 4.52 1.68 10.06 4.16 13.82v.08z"
})));